import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { References } from "./pages/References";
import { Toaster } from "./components/ui/sonner";
import { translations } from "./mock";

function App() {
  const [language, setLanguage] = useState('tr');

  return (
    <div className="App">
      <BrowserRouter>
        <Header language={language} setLanguage={setLanguage} translations={translations} />
        <Routes>
          <Route path="/" element={<Home language={language} translations={translations} />} />
          <Route path="/references" element={<References language={language} translations={translations} />} />
        </Routes>
        <Footer language={language} translations={translations} />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
